
import {isEmpty} from "lodash-es/lodash";
import {storePdp} from "@/store/product-page";
import productPage from "@/api/productPage";
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";

/*import Vue, {defineComponent} from 'vue';
import {ObserveVisibility} from 'vue-observe-visibility'

Vue.directive('observe-visibility', ObserveVisibility);*/

export default {
    storePdp,
    name: 'CampaignBlocks',
    components: {
        Single: () => import('@/components/Blocks/Block/Single.vue'),
        BlockContentPopup: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue'),
        CampaignDisplay: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/CampaignDisplay.vue'),
        ProductDisplay: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ProductDisplay.vue'),
    },
    props: {
    },
    created() {
    },
    data() {
        return {
            loading: false,
            modalTitle: '',
            listTitle: '',
            cpgDetailData: null, // cpg details modal
            cpgListData: null, // cpg list modal (view more)
            hideSection: false
        }
    },
    watch: {},
    methods: {
        handleListModal(blockValue, status = true) { // cpg list display
            console.log('setCpgModalStatus: ', blockValue, status);
            this.listTitle = status ? blockValue.modalTitle : '';
            this.cpgListData = status ? productPage.singleBlockFactory(blockValue.openCpgList) : null;
        },
        handleCampaignDetail(item, targetElm = '') { // cpg detail
            if(!item || (item && !item._coupon)) {
                this.cpgDetailData = null;
                return
            }
            console.log('open cpg detail: ', item);
            const insideBlockClipboard = targetElm.closest('.prz-blk-promo-coupon');
            if(!insideBlockClipboard && (item?.action?.value??null)) {
                this.cpgDetailData = item.action.value;
            }
        },
        visibilityRow(isVisible: boolean) {
            if (isVisible) {
                this.load();
            }
        },
        setLoading(value: boolean){
            this.loading = value;
            this.$emit('contentLoading', value, 'CampaignBlocks');
        },
        async load() {
            this.setLoading(true);
            await storePdp.dispatch('pdpDesktop/updateCampaignsData', this.campaignsConnection);
            if(!this.campaignsData) {
                this.hideSection = true;
            }

            this.setLoading(false);
        }
    },
    computed: {
        deviceType(){
            return DeviceType.desktop;
        },
        kStrings() {
            return storePdp.getters.kStrings;
        },
        campaignsConnection() {
            return storePdp.getters['pdpDesktop/campaignsConnection'];
        },
        campaignsData() {
            const data = storePdp.getters['pdpDesktop/campaignsData'];
            return !isEmpty(data) && !isEmpty(data.blockStruct) ? data.blockStruct : null;
        },
        campaignsBlocks() {
            if(isEmpty(this.campaignsData)) {
                return null;
            }
            return productPage.singleBlockFactory(this.campaignsData);
        },
    },
    mounted() {
        this.load();
    }

}
